import React from 'react';
import { NavLink } from 'react-router-dom';
import { FiArrowRight, FiCalendar, FiClock } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { blogPosts } from '../data/blogPosts';

const Blog = () => {
  return (
    <div className="bg-ms-light min-h-screen pt-12 pb-24">
      {/* Blog Hero */}
      <div className="max-w-7xl mx-auto px-4 mb-20 text-center">
        <span className="text-ms-red font-black uppercase tracking-[0.3em] text-sm mb-4 block">Ratgeber & Inspiration</span>
        <h1 className="text-5xl lg:text-7xl font-black text-ms-dark mb-6 uppercase tracking-tighter">Unser Blog</h1>
        <p className="text-xl text-ms-dark/60 font-medium max-w-2xl mx-auto">
          Wertvolle Tipps, Vergleiche und Inspirationen rund um das Thema Terrassen, Wintergärten und Outdoor-Living.
        </p>
      </div>

      {/* Blog Grid */}
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post) => (
            <NavLink 
              key={post.id} 
              to={`/blog/${post.slug}`}
              className="bg-white rounded-[2.5rem] overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border border-ms-blue/5 group flex flex-col"
            >
              <div className="relative h-64 overflow-hidden">
                <div className="absolute inset-0 bg-ms-dark/20 group-hover:bg-transparent transition-colors z-10 duration-500"></div>
                <img 
                  src={post.image} 
                  alt={post.title} 
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute top-4 left-4 z-20 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-xl text-xs font-black uppercase tracking-widest text-ms-blue">
                  Ratgeber
                </div>
              </div>
              
              <div className="p-8 flex flex-col flex-grow">
                <div className="flex items-center gap-4 text-xs font-bold text-ms-dark/40 uppercase tracking-widest mb-4">
                  <span className="flex items-center gap-1.5"><SafeIcon icon={FiCalendar} /> {post.date}</span>
                  <span className="w-1 h-1 bg-ms-dark/20 rounded-full"></span>
                  <span className="flex items-center gap-1.5"><SafeIcon icon={FiClock} /> {post.readTime}</span>
                </div>
                
                <h2 className="text-2xl font-black text-ms-dark uppercase tracking-tight mb-4 leading-tight group-hover:text-ms-blue transition-colors">
                  {post.title}
                </h2>
                
                <p className="text-ms-dark/70 font-medium text-sm leading-relaxed mb-8 flex-grow">
                  {post.excerpt}
                </p>
                
                <div className="flex items-center text-ms-blue font-black uppercase tracking-widest text-sm mt-auto">
                  Artikel lesen <SafeIcon icon={FiArrowRight} className="ml-2 group-hover:translate-x-2 transition-transform" />
                </div>
              </div>
            </NavLink>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blog;